import { z } from "zod";

import { zSchema } from "../../../../entity";

import type { OperationalErrorOptions } from "~/shared/error";
import { OperationalError } from "~/shared/error";

const zIn = zSchema
  .pick({
    id: true,
  })
  .merge(
    zSchema
      .pick({
        rating: true,
        pros: true,
        cons: true,
        text: true,
        orderNumber: true,
      })
      .partial(),
  );

type In = z.infer<typeof zIn>;

const zErrorReason = z.enum(["ORDER_NOT_FOUND"]);
const ErrorReason = zErrorReason.Enum;
type ErrorReason = z.infer<typeof zErrorReason>;

class Error extends OperationalError {
  readonly reason: ErrorReason;

  constructor(reason: ErrorReason, options?: OperationalErrorOptions) {
    super(options);
    this.reason = reason;
    this.message = "Failed to update review.";
  }
}

export { Error, ErrorReason, zErrorReason, zIn };
export type { In };
